import type { ReactNode } from 'react'
import { StructuredText } from 'react-datocms'
import { Grid } from '#src/components/Grid.js'
import type { MudLabData } from '#src/pages/mud-lab/mudLabData.js'

interface Props {
  children?: ReactNode
  data: MudLabData
}

export function MudLab(props: Props): ReactNode {
  const { grid, content } = props.data

  return (
    <div className="mudlab__page">
      <div className="mudlab__content">
        {content && <StructuredText data={content} />}

        {grid && <Grid grid={grid} galleryPath="/mud-lab/" leftRight={true} />}

        {/* {isEnabled && <p>Draft mode enabled</p>}*/}
      </div>

      {props.children}
    </div>
  )
}
